import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { UiFilterBarComponent } from '../ui-filter-bar/ui-filter-bar.component';
import { UiFilterOption } from '../ui-filter-bar/ui-filter-bar.types';
import { UiLabelTranslatePipe } from '../ui-label-translate.pipe';

@Component({
  selector: 'ui-page-tabs-header',
  standalone: true,
  imports: [UiFilterBarComponent, UiLabelTranslatePipe],
  templateUrl: './ui-page-tabs-header.component.html',
  styleUrl: './ui-page-tabs-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiPageTabsHeaderComponent {
  readonly title = input('');
  readonly description = input('');
  readonly tabs = input<UiFilterOption[]>([]);
  readonly activeTab = input('');
  readonly tabSelected = output<string>();

  onTabSelected(value: string): void {
    this.tabSelected.emit(value);
  }
}
